import { Controller } from "@hotwired/stimulus"
import { show_toast } from "../toasts"

// This controller will take its element and create a toast from it.
// The element will then be removed.
//
// The elements is a div with two divs inside:
// <div data-controller="toast-me">
//   <div class="toast-header">
//     <strong class="mr-auto">Toast Header</strong>
//   </div>
//   <div class="toast-body">
//     Some text
//   </div>
// </div>

// Connects to data-controller="toast-me"
export default class extends Controller {
  connect() {
    // Get the toast header and body
    const header = this.element.querySelector(".toast-header")
    const header_html = (header ? header.innerHTML : "")
    const body = this.element.querySelector(".toast-body")
    const body_html = (body ? body.innerHTML : "")

    // Create the toast
    if (header_html) {
      show_toast(header_html, body_html)
    } else {
      show_toast(body_html)
    }

    // Remove the element
    this.element.remove()
  }
}
